module.exports = __webpack_public_path__ + "img/dnspod.6e06970a.jpg";